export default {
  list: {
    title: 'Game',
    subtitle: 'List',
    add: 'New game',
    filterStatus: 'Filter by status',
    templatePlaceholder: 'Template',
    searchPlaceholder: 'Search...',
    tableTitle: 'Active games',
  },
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    add: 'New game',
  },
  templateList: {
    title: 'Crossword templates',
    subtitle: 'List',
    add: 'New template',
    tableTitle: 'Active templates',
    searchPlaceholder: 'Search...',
  },
  templateCreate: {
    title: 'Add',
    subtitle: 'Games',
  },
  templateEdit: {
    title: 'Edit',
    subtitle: 'Template',
  },
  card: {
    registration: 'Registration details',
    template: 'Game template',
    actions: 'Actions',
    publication: 'Publication',
  },
  preview: {
    title: 'Grid preview:',
  },
  form: {
    template: {
      label: 'Start from a template:',
      placeholder: 'Search templates by name',
      apply: 'Apply template',
      selected: 'Selected: {name} ({rows}x{columns})',
    },
    name: {
      label: 'Name:',
      invalid: 'Name is required',
    },
    prioritizeQuality: {
      label: 'High density mode',
      tooltip:
        'The system will make multiple placement attempts to maximize crossword intersections and avoid empty spaces.',
    },
    useCurrentGameReference: {
      label: 'Use current game as base',
      tooltip:
        'Uses this game’s question positions and directions as a guide when generating new games.',
    },
    columns: 'Column size:',
    rows: 'Row size:',
    style: {
      label: 'Game style:',
      default: 'Default',
      radius: 'Rounded',
      times: 'Times font',
    },
    questionColor: 'Question color:',
    font: 'Font:',
    level: {
      label: 'Level:',
      placeholder: 'Select a level',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
    },
    copyLayout: {
      label: 'Copy game layout:',
      placeholder: 'Select a base game...',
    },
    bank: {
      title: 'Answer bank',
      count: 'Quantity:',
      label: 'Bank:',
    },
    hint: 'Double-click cells to mark them as questions',
  },
  sidebar: {
    createdAt: 'Created on:',
    updatedAt: 'Updated on:',
    setDraft: 'Switch to draft',
    setCompleted: 'Complete game',
    exportHint: 'You need to save before exporting.',
    importFile: 'Import file',
    saveAsTemplate: 'Save as template',
    saveAndGenerate: 'Save and generate new game',
    emptyGridHint: 'The grid has no words. Add some to enable this.',
    fillWords: 'Insert words',
    noQuestionsHint: 'Mark at least one question on the grid.',
    syncQuestions: 'Sync questions',
  },
  templatePage: {
    clearTemplate: 'Clear template',
  },
  option: {
    answer: 'Answer',
    question: 'Question',
    merge: 'Merge',
    split: 'Split',
    arrows: 'Arrows',
    clearCell: 'Clear cell',
  },
  answerModal: {
    direction: 'Direction',
    directionHint: 'from the first letter',
    directionPlaceholder: 'Select the fill direction',
  },
  questionModal: {
    noQuestions: 'This answer has no registered questions!',
    textSize: 'Text size',
    textSizePlaceholder: 'Select a size',
    fontSize: 'Font size',
    fontSizePlaceholder: 'Select the font size',
    required: 'Required field',
    registeredQuestions: 'Registered questions',
    levelTooltipTitle: 'Difficulty levels:',
    level: 'Level',
    levelPlaceholder: 'Select the level...',
    levelInvalid: 'Level is required',
    question: 'Question',
    answerLabel: '( Answer: {answer} )',
    questionInvalid: 'Question is required',
    deleteTitle: 'Delete question',
    deleteMessage:
      'Are you sure you want to delete this question from the system?',
  },
  editQuestionModal: {
    title: 'Edit question',
    question: 'Question:',
    questionInvalid: 'Question is required',
    level: 'Level:',
    levelPlaceholder: 'Select the level...',
    levelInvalid: 'Level is required',
    warning:
      'Changes will be reflected in the word bank, not just in this puzzle.',
  },
  arrowsModal: {
    position: 'Position',
    positionPlaceholder: 'Select the position',
    direction: 'Direction',
    directionPlaceholder: 'Select the fill direction',
  },
  ungroupModal: {
    size: 'Size',
    sizePlaceholder: 'Select the size',
  },
  split: {
    third: '1/3 of the row',
    half: '1/2 of the row',
    twoThird: '2/3 of the row',
    twoColumns: '2 columns',
  },
  saveTemplateModal: {
    title: 'Save as template',
    name: 'Name:',
    placeholder: 'E.g.: Easy Grid - 15x15',
    hint: 'This template will store only the question positions for later reuse.',
    save: 'Save template',
  },
  importModal: {
    title: 'Import file (.txt)',
    howToFormat: 'How to format the file?',
    followModel: 'Follow the model below so the grid is generated correctly:',
    letters: 'Letters (A-Z): Filled cells.',
    dots: 'Period (.): Empty cells.',
    size: 'Size: All rows must have the same number of characters.',
    downloadExample: 'Download .txt template',
    confirm: 'Confirm import',
    invalidFormat: 'The file format must be .txt',
    invalidChars:
      'Invalid file! Use only letters (A-Z) and periods (.) for empty cells.',
    invalidRows: 'Invalid file: the rows have different lengths.',
  },
  unsavedModal: {
    title: 'Unsaved changes',
    message:
      'There are unsaved changes. Do you want to continue without saving?',
    continue: 'Continue',
  },
  confirm: {
    title: 'Confirmation',
    message: 'Are you sure you want to continue?',
    applyTemplateTitle: 'Confirm change',
    applyTemplateMessage:
      'Do you want to load the grid from "{name}"? This will replace your current rows and columns.',
    saveAsTemplateTitle: 'Create new template',
    saveAsTemplateMessage:
      'Do you want to save the current structure (question positions) as a new template? Current letters will be cleared in the saved template.',
    overwriteAnswer:
      'There is already an answer in this direction. Are you sure you want to continue?',
    finalizeTitle: 'Finalize game',
    finalizeMessage:
      'This game will be finalized and will no longer be editable. Do you want to continue?',
    finalize: 'Finalize',
    syncQuestionsTitle: 'Sync questions',
    syncQuestionsMessage:
      'Answers that do not have questions will be reviewed. If a matching question already exists, it will be placed on the grid in the cell linked to that answer. Do you want to continue?',
    syncQuestions: 'Sync',
  },
  alert: {
    statusBatchUpdated: 'Game statuses updated successfully!',
    layoutImported: 'Layout and clue coordinates imported successfully!',
    templateApplied: 'Template applied successfully!',
    requestCancelled: 'Request canceled by the user',
    fillAnswerFailed: 'Could not fill in the answer',
    bankNotEnough:
      'There are not {count} unique answers available with more than 3 letters in this game.',
    mergeMergedCell: 'You cannot merge another merged cell',
    mergeDirectionOnly: 'You can only merge cells horizontally or vertically',
    templateSavedSelected: 'Template saved and selected for use!',
    templateCleared:
      'The template was cleared: all question marks were removed',
    generateVariationFailed: 'Could not generate a new variation of the game.',
    cannotSaveWithBaseLayout:
      'You cannot save and generate a variation while a base layout is imported. Fill in the words first or clear the layout.',
    saveAsTemplateFirst:
      'Save this game as a template before generating new games.',
    savedLoadingVariation:
      'Game saved! Loading the newly generated variation...',
    savedButVariationFailed:
      'The game was saved, but a new variation could not be generated. Please try again.',
    gameSaved: 'Game saved successfully!',
    statusUpdated: 'Status updated successfully!',
    templateSaved: 'Template saved successfully!',
    questionDeleted: 'Question deleted successfully!',
    questionUpdated: 'Question updated successfully!',
    wordTooLong: 'Word is too long',
    syncQuestionsSuccess: 'Questions synced successfully!',
    syncQuestionsError: 'Error syncing questions. Please try again.',
  },
};
